import React from 'react';
import { Container, Typography } from '@mui/material';

export default function ForbiddenPage() {
  return (
    <Container>
      <Typography variant="h4" color="error">Accesso negato</Typography>
      <Typography>Non hai i permessi per accedere a questa pagina.</Typography>
    </Container>
  );
}